var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWifi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41.905,
    height: 29.333,
    viewBox: "0 0 41.905 29.333",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-wifi",
    "data-name": "Icon awesome-wifi",
    d: "M41.571,10.3a30.444,30.444,0,0,0-41.238,0A1.041,1.041,0,0,0,.31,11.8l2.242,2.224a1.063,1.063,0,0,0,1.467.025,25.121,25.121,0,0,1,33.867,0,1.064,1.064,0,0,0,1.467-.025L41.595,11.8a1.041,1.041,0,0,0-.024-1.5ZM20.952,23.2a4.19,4.19,0,1,0,4.19,4.19A4.19,4.19,0,0,0,20.952,23.2Zm13.27-5.473a20.1,20.1,0,0,0-26.54,0,1.035,1.035,0,0,0-.037,1.516L9.9,21.47a1.069,1.069,0,0,0,1.444.052,14.747,14.747,0,0,1,19.217,0A1.068,1.068,0,0,0,32,21.47l2.255-2.226A1.035,1.035,0,0,0,34.222,17.729Z",
    transform: "translate(0 -2.25)",
    fill: "#cea95a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWifi);
export default __webpack_public_path__ + "static/media/iconWifi.b3e36c6972b368680f627ea7755112c9.svg";
export { ForwardRef as ReactComponent };